/**
 * This is a component we use throughout the app to maintain uniform spacings across views
 */
import Column from '@amzn/meridian/column';
import Heading from '@amzn/meridian/heading';
import Row from '@amzn/meridian/row';
import React from 'react';

interface PageLayoutProps {
    children: React.ReactNode;
    title?: string;
}

export const contentId = 'page-layout-content';

export const PageLayout = ({ title, children }: PageLayoutProps) => {
    return (
        <Column alignmentHorizontal="center" spacingInset="500 200 600">
            <Column width="96%" maxWidth="2200px" spacing="500">
                {/* If we have a title prop, render the row for the heading */}
                {title && (
                    <Row widths={['fill', 'fit']}>
                        <Heading level={1} type="d100" data-testid="page-layout-title-heading">
                            {title}
                        </Heading>
                    </Row>
                )}
                {children}
            </Column>
        </Column>
    );
};
